import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';

import { Leaderboard } from '../components/Leaderboard';
import { configureReduxQuerySync } from '../utils/configure-redux-query-sync';

export const PlayerAwardsLeaderboardProvider = ({ store, data }) => {
    useEffect(() => {
        configureReduxQuerySync(store);
    }, []);

    return (
        <Provider store={store}>
            <Leaderboard {...data} />
        </Provider>
    );
};

PlayerAwardsLeaderboardProvider.propTypes = {
    store: PropTypes.object.isRequired,
    data: PropTypes.object
};
